import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `FinancingTypeProduct/GetTypeProductByProductId/${id}`, method: 'GET', body: null, token: token })
}
